import React from "react";
import {Link} from "react-router-dom";
import {IoIosArrowForward} from "react-icons/io";
import {lite} from "../lite";

interface AboutProps {
    className?: string
}

export function About({className}: AboutProps) {
    return (
        <div className={className}>
            <hr/>
            <p>
                I'm a UX researcher with a Master's degree in Computing Science from the University of Glasgow. My recent work has been centred around designing and building novel mixed reality prototypes.
            </p>
            <p>
                Staring at a computer screen all day makes me want to touch grass so I'm a fairly outdoorsy guy. Some of my hobbies include running, cycling, hiking, and climbing. I'm pretty lazy though, I stay in when it gets too cold and play strategy games instead in my free time.
            </p>
            <hr/>
            {/* phones and narrow screens only (App.css), where the menu no longer has projects */}
            <Link className="button" id="viewProjects" to="/projects">view projects<IoIosArrowForward/></Link>
            {lite && (
                <p className="lite-note">
                    You're seeing a lighter version of this site because data saving is on. Photos and some effects are switched off.
                </p>
            )}
        </div>
    );
}
